import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getAttributeVocabulary,
	getAttributeVocabularyEndpoint,
	type QueryError,
	type GetAttributeVocabularyResult,
	type GetAttributeVocabularyRequestOptions,
} from '../getAttributeVocabulary';
export * from '../getAttributeVocabulary';

export type GetAttributeVocabularyQueryParams =
	GetAttributeVocabularyRequestOptions;
export type GetAttributeVocabularyQueryKey = [
	string,
	GetAttributeVocabularyQueryParams,
];

export type GetAttributeVocabularyQueryOptions = Omit<
	UseQueryOptions<
		GetAttributeVocabularyResult,
		QueryError,
		GetAttributeVocabularyResult,
		GetAttributeVocabularyQueryKey
	>,
	'queryKey' | 'queryFn'
> & {
	queryFn?: typeof getAttributeVocabulary;
};

export const GetAttributeVocabularyReactQueryKey =
	getAttributeVocabularyEndpoint;

/**
 * react-query wrapper for `getAttributeVocabulary`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetAttributeVocabulary = (
	queryKeyParams: GetAttributeVocabularyQueryParams,
	{
		queryFn = getAttributeVocabulary,
		...options
	}: GetAttributeVocabularyQueryOptions = {},
) =>
	useQuery<
		GetAttributeVocabularyResult,
		QueryError,
		GetAttributeVocabularyResult,
		GetAttributeVocabularyQueryKey
	>({
		queryKey: [getAttributeVocabularyEndpoint, queryKeyParams],
		queryFn: ({queryKey, signal}) => queryFn({...queryKey[1]}, signal),
		...options,
	});

export default useReactQueryGetAttributeVocabulary;
